import { render, staticRenderFns } from "./ShopView.vue?vue&type=template&id=46b46541&scoped=true&"
import script from "./ShopView.vue?vue&type=script&lang=js&"
export * from "./ShopView.vue?vue&type=script&lang=js&"
import style0 from "./ShopView.vue?vue&type=style&index=0&id=46b46541&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b46541",
  null
  
)

export default component.exports